export type ScheduleCalendarType = "Day" | "Week" | "Month";
export const ScheduleCalendarTypes = {
    Day: "Day" as ScheduleCalendarType,
    Week: "Week" as ScheduleCalendarType,
    Month: "Month" as ScheduleCalendarType
};